import React from "react";
import UserProfileLayout from "../../../components/layout/userprofilelayout/userprofilelayout";
import ActivityLogsComp from "../../../components/usersettings/activitylogscomp";

export default function ActivityLogs() {
  return (
    <>
      <UserProfileLayout>
        <div className="w-full bg-white rounded-2xl border border-primary50 gap-4 flex mb-4">
          <ActivityLogsComp />
        </div>
      </UserProfileLayout>
    </>
  );
}
